<template>
  <div>
    <span class="text-title">
      <i v-if="priorityIcon" :class="priorityIcon"></i>
      Priority:
    </span>
    <span class="text-body">
      {{ servicePriority }}
    </span>
  </div>
</template>

<script>
import { capitalize } from "@/mixins";
export default {
  props: {
    priority: {
      type: String,
      default: "low",
    },
  },
  computed: {
    servicePriority() {
      return capitalize(this.priority) || "Low";
    },
    priorityIcon() {
      switch (this.priority) {
        case "high": {
          return "fas fa-long-arrow-alt-up";
        }
        case "normal": {
          return null;
        }
        default:
          return "fas fa-long-arrow-alt-down";
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
